import makeStyles from "@mui/styles/makeStyles";
import { DateTimeInput } from "components/FormControls/DateTimeInput";
import { RequiredFieldLabel } from "components/FormControls/RequiredFieldLabel";
import { OLModal } from "components/Tooltips/OLModal";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import dayjs, { Dayjs } from "dayjs";
import { Field, Form, Formik } from "formik";
import { useMessage } from "hooks/intl";
import moment from "moment";

export const useStyles = makeStyles((theme: OLTheme) => ({
  modal: {
    padding: 0,
    width: "340px",
  },
  dateTimePicker: {
    display: "block",
  },
  actionBar: {
    display: "flex",
    justifyContent: "end",
  },
}));

interface Props {
  isDialogOpen: boolean;
  closeDialog: () => void;
  dialog?: Dialog | null;
  setFieldValue: (value: string) => void;
  currentValue?: string;
  initialValue?: string | Dayjs;
}

export type Dialog = {
  title: string;
  description?: React.ReactElement | string;
  code: string;
};

export const EffectDateTimeDialog = ({
  isDialogOpen,
  closeDialog,
  dialog,
  setFieldValue,
  currentValue,
  initialValue,
}: Props) => {
  const { message } = useMessage();
  const formatDate = (date: Dayjs) => moment(date.toDate()).toISOString(true);

  return isDialogOpen && dialog ? (
    <Formik
      initialValues={{ date: initialValue || dayjs() }}
      onSubmit={(values) => {
        // Necessary if the user submits the default value.
        const dateValue =
          typeof values.date === "string"
            ? values.date
            : formatDate(values.date);

        const injectedValue = dialog.code.replace("{{DATE}}", `'${dateValue}'`);
        setFieldValue(`<#>${injectedValue}</#>`);
        closeDialog();
      }}
    >
      {({ handleSubmit, setFieldValue }) => {
        return (
          <Form onSubmit={handleSubmit}>
            <Field name="date">
              {({ field }: { field: any }) => (
                <OLModal
                  clearIcon={false}
                  open={isDialogOpen}
                  onClose={closeDialog}
                  header={message({ id: "staticDate" })}
                  submitText={message({ id: "save" })}
                  cancelText={message({ id: "cancel" })}
                  submitAction={() => handleSubmit()}
                >
                  <DateTimeInput
                    width="100%"
                    name={field.name}
                    format="yyyy-MM-dd HH:mmXXX"
                    onChange={(date: Dayjs) =>
                      setFieldValue(field.name, formatDate(date))
                    }
                    label={
                      <RequiredFieldLabel
                        text={message({ id: "staticDate" })}
                      />
                    }
                    defaultValue={new Date()}
                    value={field.value}
                    disablePast
                  />
                </OLModal>
              )}
            </Field>
          </Form>
        );
      }}
    </Formik>
  ) : null;
};
